export type PageMetaResponse = {
    h1: string | null;
    metaTitle: string | null;
    metaDescription: string | null;
    metaKeywords: string | null;
    robots: string | null;
};

// SEO-05: optional per-page-type fallback values used when the API returns no meta
export type PageMetaDefaults = {
    title?: string;
    description?: string;
    robots?: string;
};

export const usePageMeta = async (defaults?: PageMetaDefaults) => {
    const route = useRoute();
    const {apiQuery} = useApi();

    const {data: pageMeta} = await useAsyncData<{ data: PageMetaResponse | null }>(
        `page-meta-${route.path}`,
        () => apiQuery<{ data: PageMetaResponse | null }>(
            'public/page-meta', 'GET', {query: {path: route.path}}
        ),
    );

    useSeoMeta({
        title: () => pageMeta.value?.data?.metaTitle || defaults?.title || undefined,
        ogTitle: () => pageMeta.value?.data?.metaTitle || defaults?.title || undefined,
        description: () => pageMeta.value?.data?.metaDescription || defaults?.description || undefined,
        ogDescription: () => pageMeta.value?.data?.metaDescription || defaults?.description || undefined,
        ogType: 'website',
        keywords: () => pageMeta.value?.data?.metaKeywords || undefined,
        robots: () => pageMeta.value?.data?.robots || defaults?.robots || undefined,
    });

    return pageMeta;
};
